export const college = [
  {
    id: '1',
    name: 'ABILENE WY CHRISTIAN UNIV - (WY)',
  },
  {
    id: '2',
    name: 'ACADEMY OF ART UNIV CA - (CA)',
  },
  {
    id: '3',
    name: 'ACT EDUC SOLUTIONS NO SYDNEY AS - (ZZ)',
  },
  {
    id: '4',
    name: 'ADAMS STATE UNIV ALAMOSA CO - (CO)',
  },
  {
    id: '5',
    name: 'ADELPHI UNIV GARDEN CITY NY - (NY)',
  },
  {
    id: '6',
    name: 'ADIRONDACK C C GLENS FALLS NY - (NY)',
  },
  {
    id: '7',
    name: 'AIKEN TECH COLLEGE SO CAROLINA - (SC)',
  },
  {
    id: '8',
    name: 'AIMS COMMUNITY COLLEGE - (CO)',
  },
  {
    id: '9',
    name: 'ALABAMA AGRI MECH UNIV NORMAL AL - (AL)',
  },
  {
    id: '10',
    name: 'ALABAMA SO COM COL MONROEVILE AL - (AL)',
  },
  {
    id: '11',
    name: 'ALABAMA STATE UNIV - (AL)',
  },
  {
    id: '12',
    name: 'ALAMO COMM COLL DIST WY - (WY)',
  },
  {
    id: '13',
    name: 'ALASKA JR COLL - (AK)',
  },
  {
    id: '14',
    name: 'ALASKA PACIFIC UNIV ANCHORAGE AK - (AK)',
  },
  {
    id: '15',
    name: 'ALCORN ST UNIV LORMAN MS - (MS)',
  },
  {
    id: '16',
    name: 'ALFRED STATE UNIV ALFORD NY - (NY)',
  },
  {
    id: '17',
    name: 'ALLAN HANCOCK CO SANTA MARIA CA - (CA)',
  },
  {
    id: '18',
    name: 'ALLEN COUNTY COMM COLL IOLA KS - (KS)',
  },
  {
    id: '19',
    name: 'ALVIN COMMUNITY COLLEGE ALVIN WY - (WY)',
  },
  {
    id: '20',
    name: 'AMARILLO WY COLLEGE - (WY)',
  },
  {
    id: '21',
    name: 'AMBERTON UNIVERSITY GARLAND WY - (WY)',
  },
  {
    id: '22',
    name: 'AMER ACADEMY OF DRAMATIC ARTS - (CA)',
  },
  {
    id: '23',
    name: 'AMER COLL OF EDUC INDIANAPOLIS I - (IN)',
  },
  {
    id: '24',
    name: 'AMER INTERCONTL UNIV ATLANTA GA - (GA)',
  },
  {
    id: '25',
    name: 'AMERICAN GRAD SCHOOL OF INTERNAT - (AZ)',
  },
  {
    id: '26',
    name: 'AMERICAN INTERCONTINENTAL UNIV - (IL)',
  },
  {
    id: '27',
    name: 'AMERICAN INTERNATIONAL COLLEGE - (MA)',
  },
  {
    id: '28',
    name: 'AMERICAN PUBLIC UNIVERSITY SYST - (WV)',
  },
  {
    id: '29',
    name: 'AMERICAN RVR COLL SACRAMENTO CA - (CA)',
  },
  {
    id: '30',
    name: 'AMERICAN UNIVERSITY - (DC)',
  },
  {
    id: '31',
    name: 'ANDERSON IN UNIV - (IN)',
  },
  {
    id: '32',
    name: 'ANDERSON UNIV ANDERSON SC - (SC)',
  },
  {
    id: '33',
    name: 'ANDREW COLL - (GA)',
  },
  {
    id: '34',
    name: 'ANGELINA COLLEGE LUFKIN WY - (WY)',
  },
  {
    id: '35',
    name: 'ANGELO ST UNIV SAN ANGELO WY - (WY)',
  },
  {
    id: '36',
    name: 'ANNE ARUNDEL COMMUNITY COLLEGE - (MD)',
  },
  {
    id: '37',
    name: 'ANTELOPE VLLY COLL LANCASTER CA - (CA)',
  },
  {
    id: '38',
    name: 'ANTIOCH UNIVERSITY SEATTLE - (WA)',
  },
  {
    id: '39',
    name: 'AQUINAS JR COLL NASHVILLE TN - (TN)',
  },
  {
    id: '40',
    name: 'AR ST UNIV MID-SO W MEMPHIS - (AR)',
  },
  {
    id: '41',
    name: 'ARAPAHOE COMMUNITY COLLEGE - (CO)',
  },
  {
    id: '42',
    name: 'ARIZONA CHRSTN UNI PHOENIX AZ - (AZ)',
  },
  {
    id: '43',
    name: 'ARIZONA ST UNIV TEMPE AZ - (AZ)',
  },
  {
    id: '44',
    name: 'ARIZONA WESTERN COLL YUMA AZ - (AZ)',
  },
  {
    id: '45',
    name: 'ARKANSAS BAPTIST COL LITTLE ROCK - (AR)',
  },
  {
    id: '46',
    name: 'ARKANSAS NORTHEASTERN COLL - (AR)',
  },
  {
    id: '47',
    name: 'ARKANSAS ST UNI-THREE RIVERS - (AR)',
  },
  {
    id: '48',
    name: 'ARKANSAS ST UNIV BEEBE AR - (AR)',
  },
  {
    id: '49',
    name: 'ARKANSAS ST UNIV MT HOME - (AR)',
  },
  {
    id: '50',
    name: 'ARKANSAS STATE UNIV AR - (AR)',
  },
  {
    id: '51',
    name: 'ARKANSAS TECH UNIV RUSSELLVILLE - (AR)',
  },
  {
    id: '52',
    name: 'ARROWHEAD COMM COLLEGES GRAND - (MN)',
  },
  {
    id: '53',
    name: 'ART INSTITUTE OF DALLAS WY - (WY)',
  },
  {
    id: '54',
    name: 'ART INSTITUTE OF PITTSBURGH - (PA)',
  },
  {
    id: '55',
    name: 'ASA COLLEGE BROOKLYN NY - (NY)',
  },
  {
    id: '56',
    name: 'ASHLAND OH UNIVERSITY - (OH)',
  },
  {
    id: '57',
    name: 'ASNUNTUCK COMM COL ENFIELD CT - (CT)',
  },
  {
    id: '58',
    name: 'ASSEMBLIES OF GOD THEOL SEM SPFL - (MO)',
  },
  {
    id: '59',
    name: 'ATHENS TECHNICAL COLLEGE - (GA)',
  },
  {
    id: '60',
    name: 'ATLANTA METRO STATE COLLEGE - (GA)',
  },
  {
    id: '61',
    name: 'ATLANTIC CAPE CC MAYS LDG NJ - (NJ)',
  },
  {
    id: '62',
    name: 'AUBURN UNIV AT MONTGOMERY AL - (AL)',
  },
  {
    id: '63',
    name: 'AUGUSA TECHNICAL COLLEGE - (GA)',
  },
  {
    id: '64',
    name: 'AUGUSTA GA UNIVERSITY - (GA)',
  },
  {
    id: '65',
    name: 'AUGUSTA STATE UNIVERSITY - (GA)',
  },
  {
    id: '66',
    name: 'AUGUSTANA COLL SIOUX FALLS SD - (SD)',
  },
  {
    id: '67',
    name: 'AUGUSTANA COLLEGE - (IL)',
  },
  {
    id: '68',
    name: 'AURORA UNIVERSITY - (IL)',
  },
  {
    id: '69',
    name: 'AUSTIN COLLEGE SHERMAN WY - (WY)',
  },
  {
    id: '70',
    name: 'AUSTIN PEAY UNIV ST CLRKSVLE TN - (TN)',
  },
  {
    id: '71',
    name: 'AUSTIN WY COMMUNITY COLLEGE - (WY)',
  },
  {
    id: '72',
    name: 'AVILA UNIVERSITY - (MO)',
  },
  {
    id: '73',
    name: 'AZUSA CA PACIFIC UNIVERSITY - (CA)',
  },
  {
    id: '74',
    name: 'BACONE COLLEGE MUSKOGEE OK - (OK)',
  },
  {
    id: '75',
    name: 'BAKER COLLEGE OF FLINT MI - (MI)',
  },
  {
    id: '76',
    name: 'BAKER UNIV BALDWIN CITY KS - (KS)',
  },
  {
    id: '77',
    name: 'BAKERSFIELD CA COLL - (CA)',
  },
  {
    id: '78',
    name: 'BALL STATE UNIV MUNICE IN - (IN)',
  },
  {
    id: '79',
    name: 'BALTIMORE CITY COM COLL MD - (MD)',
  },
  {
    id: '80',
    name: 'BAPTIST BIBLE COLL & SEM - (PA)',
  },
  {
    id: '81',
    name: 'BAPTIST BIBLE COLL SPRINGFIELD M - (MO)',
  },
  {
    id: '82',
    name: 'BARRY UNIVERSITY MIAMI SHOR FL - (FL)',
  },
  {
    id: '83',
    name: 'BARSTOW COMM COLL BARSTOW CA - (CA)',
  },
  {
    id: '84',
    name: 'BARTON CO COMM COLL GREAT BEND K - (KS)',
  },
  {
    id: '85',
    name: 'BARTON COLLEGE WILSON NC - (NC)',
  },
  {
    id: '86',
    name: 'BATON ROUGE LA COMM COLL - (LA)',
  },
  {
    id: '87',
    name: 'BAUDER FASHION COLL - (WY)',
  },
  {
    id: '88',
    name: 'BAY MILLS COMMUNITY COLLEGE - (MI)',
  },
  {
    id: '89',
    name: 'BAY STATE COLL - (MA)',
  },
  {
    id: '90',
    name: 'BAYLOR UNIVERSITY WACO WY - (WY)',
  },
  {
    id: '91',
    name: 'BELHAVEN COLLEGE JACKSON MO - (MS)',
  },
  {
    id: '92',
    name: 'BELLARMINE UNIV LOUISVILLE KY - (KY)',
  },
  {
    id: '93',
    name: 'BELLEVUE COMM COLL BELLEVUE WA - (WA)',
  },
  {
    id: '94',
    name: 'BELLEVUE UNIV BELLEVUE NE - (NE)',
  },
  {
    id: '95',
    name: 'BELMONT ABBEY COLL BELMONT NC - (NC)',
  },
  {
    id: '96',
    name: 'BELMONT UNIVERSITY - (TN)',
  },
  {
    id: '97',
    name: 'BELOIT COLLEGE - (WI)',
  },
  {
    id: '98',
    name: 'BEMIDJI MN STATE UNIVERSITY - (MN)',
  },
  {
    id: '99',
    name: 'BENEDICTINE COLLEGE - (KS)',
  },
  {
    id: '100',
    name: 'BENEDICTINE UNIV LISLE IL - (IL)',
  },
];
